export enum Status {
  NONE = "none",
  LOADING = "loading",
  ERROR = "error",
}
